import { Palette } from 'lucide-react';
import type { ThemeName } from '../../../themes';

export function AppearanceTab({ t, theme, setTheme }: {
  t: (k: string) => string; theme: string; setTheme: (t: ThemeName) => void;
}) {
  return (
    <div className="space-y-6">
      <h2 className="text-lg font-semibold text-[var(--color-text)]">{t('settings.appearance')}</h2>
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-[var(--color-text-secondary)] mb-2">
            <Palette size={14} className="inline mr-2" />
            {t('settings.theme')}
          </label>
          <div className="flex gap-3">
            {['default', 'dark'].map((th) => (
              <button
                key={th}
                onClick={() => setTheme(th as ThemeName)}
                className={`px-6 py-4 rounded-lg border text-sm font-medium transition-colors flex flex-col items-center gap-2 ${
                  theme === th
                    ? 'border-[var(--color-primary)] bg-[var(--color-primary-light)] text-[var(--color-primary)] ring-2 ring-[var(--color-primary)]/30'
                    : 'border-[var(--color-border)] text-[var(--color-text-secondary)] hover:bg-[var(--color-surface-hover)]'
                }`}
              >
                <div className={`w-12 h-8 rounded border ${
                  th === 'default' ? 'bg-white border-gray-300' : 'bg-gray-800 border-gray-600'
                }`} />
                {t(`settings.theme${th === 'default' ? 'Default' : 'Dark'}`)}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
